import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Header from "./Components/Header";
import CartMenu from "./Components/CartMenu";
import MobileMenu from "./Components/MobileMenu";
import Home from "./Components/Home";
import CallSection from "./Components/CallSection";
import Footer from "./Components/Footer";
import QuickViewModal from "./Components/QuickViewModal";
import AddToCartModal from "./Components/AddToCartModal";
import WishListModal from "./Components/WishListModal";
import About from "./Components/About";
import Service from "./Components/Service";
import Team from "./Components/Team";
import Shop from "./Components/Shop";
import ProductDetail from "./Components/ProductDetail";
import Cart from "./Components/Cart";
import WishList from "./Components/WishList";
import Checkout from "./Components/Checkout";
import OrderTracking from "./Components/OrderTracking";
import Account from "./Components/Account";
import Login from "./Components/Login";
import Register from "./Components/Register";
import Contact from "./Components/Contact";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../src/App.css"
import "../src/public/css/font-icons.css";
// import "../src/public/css/plugins.css";
import "../src/public/css/style.css";
import "../src/public/css/responsive.css";
// import "../src/public/js/nice-select.min.js";
// import "jquery-nice-select/css/nice-select.css";
// import "../src/public/js/main.js";
// import "../src/public/js/plugins.js";

// ProtectedRoute wrapper
// function ProtectedRoute({ children }) {
//   const isAuthenticated = !!localStorage.getItem("userToken");
//   return isAuthenticated ? children : <Navigate to="/register" />;
// }

function App() {
  return (
    <>
      <Router>
        <Header />
          <ToastContainer/>
        <MobileMenu />
        <Routes>
          <Route path="/about" element={<About />} />
          <Route path="/service" element={<Service />} />
          <Route path="/team" element={<Team />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/product/:id" element={<ProductDetail />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/wishlist" element={<WishList />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/order-tracking" element={<OrderTracking />} />
          <Route path="/account" element={<Account />} />
          <Route path="/login" element={
            !localStorage.getItem("userToken") ? <Login /> : <Navigate to="/" />
          } />
          <Route path="/register" element={
            !localStorage.getItem("userToken") ? <Register /> : <Navigate to="/" />
          } />
          <Route path="/contact" element={<Contact />} />
          <Route path="/" element={
            <>
              <CartMenu />
              <Home />
              <QuickViewModal />
              <AddToCartModal />
              <WishListModal />
            </>
          } />
        </Routes>
        <CallSection />
        <Footer />
      </Router>
    </>
  );
}

export default App;